// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createPinsNotRegistered} from '../../shared/repositories';

export const createPinsNotRegisteredReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const pinsNotRegisteredState = getState().reports.pinsNotRegistered;

        const reportCriteria = {
            dealers: pinsNotRegisteredState.selectedDealers,
            ...pinsNotRegisteredState.criteria
        };

        try {

            const data = await createPinsNotRegistered(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_PINS_NOT_REGISTERED_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/action-creators/create-report.js